import { Link, useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, Store, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Painel", icon: LayoutDashboard },
  { to: "/admin/produtos", label: "Produtos", icon: Package },
  { to: "/admin/pedidos", label: "Pedidos", icon: ShoppingCart },
];

export default function AdminLayout({ children, title }) {
  const { pathname } = useLocation();
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-[#151515] text-[#F8F7F4]">
      <aside className="w-64 bg-[#0f0f0f] border-r border-white/5 flex-col hidden md:flex">
        <div className="px-6 py-6 font-serif text-2xl">Ateliê<span className="text-[#B89C65]">.</span> <span className="text-xs align-top overline text-white/40">admin</span></div>
        <nav className="flex-1 px-3 space-y-1">
          {NAV.map((n) => {
            const active = pathname === n.to;
            const Icon = n.icon;
            return (
              <Link key={n.to} to={n.to} data-testid={`admin-nav-${n.label}`}
                className={`flex items-center gap-3 px-3 py-3 text-sm transition-colors ${active ? "bg-[#B89C65] text-white" : "text-white/60 hover:bg-white/5 hover:text-white"}`}>
                <Icon size={18} /> {n.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-3 space-y-1 border-t border-white/5">
          <Link to="/" className="flex items-center gap-3 px-3 py-3 text-sm text-white/60 hover:text-white transition-colors"><Store size={18} /> Ver loja</Link>
          <button onClick={() => { logout(); navigate("/"); }} className="w-full flex items-center gap-3 px-3 py-3 text-sm text-white/60 hover:text-white transition-colors"><LogOut size={18} /> Sair</button>
        </div>
      </aside>
      <div className="flex-1 flex flex-col">
        <header className="border-b border-white/5 px-6 md:px-10 py-6 flex items-center justify-between">
          <h1 className="font-serif text-3xl">{title}</h1>
          <div className="md:hidden flex gap-3">
            {NAV.map((n) => <Link key={n.to} to={n.to} className="overline text-white/60">{n.label}</Link>)}
          </div>
        </header>
        <main className="flex-1 p-6 md:p-10 overflow-auto">{children}</main>
      </div>
    </div>
  );
}
